import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';
import {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {DesignedHeader} from '../../../commonComponents/DesignedHeader';
import {RqGetAllProducts} from '../../../reactQuery/apis';

const BestSeller = ({data}) => {
  const [isWeb, setIsWeb] = useState(window.innerWidth > 768);

  const {data: products} = RqGetAllProducts();

  const sliderRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsWeb(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {breakpoint: 1024, settings: {slidesToShow: 3}},
      {breakpoint: 768, settings: {slidesToShow: 3}},
      {breakpoint: 480, settings: {slidesToShow: 2}},
    ],
  };

  const navigationButtons = [
    {icon: <LeftOutlined className={'text-2xl p-2 bg-white rounded-full bg-opacity-50'} />, onClick: () => sliderRef.current.slickPrev()},
    {icon: <RightOutlined className={'text-2xl p-2 bg-white rounded-full bg-opacity-50'} />, onClick: () => sliderRef.current.slickNext(), className: 'right-2'},
  ];

  return (
    <div className={'w-full overflow-hidden px-4'}>
      <div className={'rounded-lg lg:px-10 py-5'}>
        <div className={'text-center'}>
          <DesignedHeader title={data.title} description={data.description} />
        </div>
        <div className={'slider-container mt-2 relative -mx-2'}>
          <Slider ref={sliderRef} {...settings}>
            {products?.slice(0, 10).map(item => (
              <div key={item.id} className={'px-2'}>
                <div className={'relative group w-full md:h-[200px] h-[150px] rounded-md overflow-hidden'}>
                  <img
                    src={Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl}
                    alt={item.alt}
                    className={'w-full h-full object-cover rounded-md transition-transform duration-300 group-hover:scale-105'}
                  />
                  <div
                    role={'button'}
                    tabIndex={0}
                    onClick={() => navigate('/product')}
                    onKeyDown={e => e.key === 'Enter' && navigate(item.link)}
                    className={'absolute bottom-0 left-0 w-full bg-black/30 text-white text-center py-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300 cursor-pointer'}
                  >
                    View More
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          {isWeb && navigationButtons.map((button, index) => (
            <div
              key={index}
              role={'button'}
              tabIndex={0}
              onClick={button.onClick}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && button.onClick()}
              className={`absolute top-1/2 ${index === 0 ? 'left-2' : button.className} -translate-y-1/2 cursor-pointer`}
            >
              {button.icon}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

BestSeller.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
      }),
    ).isRequired,

  }).isRequired,
};

export default BestSeller;
